module.exports = __webpack_public_path__ + "img/eyedropper.f2da1166.svg";